import React, { Component } from "react";

import HeaderText from "page/HeaderText";
import Form from "page/Form";

import queryStringUtils from "utils/query-string";

export default class extends Component {
  onSubmit = ({ name, password }) => {
    const { postData } = this.props;
    const token = queryStringUtils.parse(window.location.search).token;
    const data = { name, password, role_slug: "superuser", token };
    postData(data);
  };
  render() {
    const { user } = this.props.data;
    const initialValues = { email: user.email, name: user.name };
    return (
      <div>
        <HeaderText title={"Accept Superuser"} />
        <Form
          onSubmit={this.onSubmit}
          initialValues={initialValues}
          roleOptions={[{ label: "Superuser", value: "superuser" }]}
          showPasswordField={user.passwordExists == 0}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page/Superuser/index.js